
export const ensureFBInit = () => new Promise((resolve) => {
  if (window.fbInitialized) {
    resolve();
  } else {
    window.fbInitializedFunc = () => {
      resolve();
    };
  }
});
